import { ICreateCertificateInput, ITemplate } from 'graphql/types';
import { TExtraCategoryInput } from 'organisation/types';

export type TCertificateOption = {
    id: string;
    name: string;
};

export type TCertificatePreviewData = {
    template?: ITemplate;
    primaryColor?: string;
    secondaryColor?: string;
    title?: string;
    subtitle?: string;
    text?: string;
    signatureFileId?: string;
    expiry?: number | null;
};

/**
 * The subset of certificate fields needed to render the template preview.
 * Satisfied both by the fetched `CertificateEdit` fragment and by an object
 * assembled from live edit-form values, so a single preview component can
 * accept either source.
 */
export interface ICertificatePreviewSource {
    template?: ITemplate | null;
    primaryColor?: string | null;
    secondaryColor?: string | null;
    title?: string | null;
    subtitle?: string | null;
    text?: string | null;
    expiry?: number | null;
    signatureFile?: { url?: string | null } | null;
    customTemplate?: { id?: string | null } | null;
}

export type TCertificateFormValues = Omit<
    ICreateCertificateInput,
    'scoring' | 'title' | 'ref'
> & {
    title: string;
    reference?: string | null;
    scoring?: {
        score?: number | null;
        scoringSystemId?: string | null;
    } | null;
    extraCategories?: TExtraCategoryInput;
};

export type TNotificationFormFields = Pick<
    ICreateCertificateInput,
    | 'sendAchievedMail'
    | 'sendNotification'
    | 'notificationOffset'
    | 'notificationOffsetScale'
    | 'notificationTargets'
>;

export type TExternalCertificateFormValues = Pick<
    ICreateCertificateInput,
    | 'name'
    | 'sendNotification'
    | 'notificationOffset'
    | 'notificationOffsetScale'
    | 'notificationTargets'
> & {
    reference?: string | null;
    requiresValidation?: boolean | null;
    scoring?: {
        score?: number | null;
        scoringSystemId?: string | null;
    } | null;
    extraCategories?: TExtraCategoryInput;
};

export enum EScoringSystemOption {
    NoScoringSystem = 'NO_SCORING_SYSTEM',
}
